<template>
  <page>
    <template slot="content">
    <help-content :title="'SMS認証コードが届かない'">
      <template slot="content">
        <div class="text">
          電話番号を確認したうえでSMSが届かない場合は、以下が考えられます。
        </div>
        <div class="text">
          ・迷惑メール設定などでSMSの受信を制限している<br>
          ・海外事業者からのSMSの受信を制限している<br>
          ・ご利用の端末にSMS機能をオプションでつけていない<br>
          ・携帯電話番号ポータビリティ（MNP）後でSMSが受信できない<br>
          ・SMSの保存容量がいっぱいになっている<br>
          ・回線の契約内容により利用できない<br>
          ・モバイル通信ができない状態になっている<br><br>
          上記ご確認のうえ、再度お試しください。<br>
          ※新規会員登録時に、複数回送信してもSMSが届かない場合は、メールアドレスでの登録をお試しください。
        </div>
      </template>
    </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help30.vue